import { render, staticRenderFns } from "./report-analysis.vue?vue&type=template&id=2b03841b&"
import script from "./report-analysis.vue?vue&type=script&lang=js&"
export * from "./report-analysis.vue?vue&type=script&lang=js&"
import style0 from "./report-analysis.vue?vue&type=style&index=0&id=2b03841b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports